import React, {useCallback} from 'react';
import {t} from '../../../localization';
import {useWarnLeavePage} from '../../../navigation/hooks';
import {useScheduleDataContext} from '../../../services';

export const WarnLeaveEditing: React.FC = () => {
  const context = useScheduleDataContext();
  const condition = useCallback(() => context.droppedTasks.length > 0, [
    context.droppedTasks,
  ]);

  const clearEditState = useCallback(() => context.cancelEdit(), [context]);

  useWarnLeavePage(
    t('screens.schedule.edit.warning.title'),
    t('screens.schedule.edit.warning.description'),
    condition,
    clearEditState,
  );
  return null;
};
